import { Error } from '../types/Errors/Error';
export const NEW_ERROR = 'NEW_ERROR'
export const CLEAR_ALL = 'CLEAR_ALL'


interface NewErrorAction {
    type: typeof NEW_ERROR
    payload: {
        error: Error
    }
}

interface ClearAllAction {
    type: typeof CLEAR_ALL
}

export type ActionType = NewErrorAction | ClearAllAction

export class Actions {

    static clearAll(): ClearAllAction {
        return {
            type: CLEAR_ALL
        }
    }

    static newError(err: Error): NewErrorAction {
        return {
            type: NEW_ERROR,
            payload: {
                error: err
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/errorInfo.ts